import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

export type IconSize = 'xs' | 'sm' | 'lg' | 'xl' | '';

@Component({
  selector: 'app-stars',
  standalone: true,
  templateUrl: './stars.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './stars.component.scss'
})
export class StarsComponent {
  @Input() public numStarsSelected: number = 0;
  @Input() public disabled: boolean = false;
  @Input() public size: IconSize = '';
  @Input() public maxStars: number = 5;

  @Output() ratingSelected = new EventEmitter<number>();

  protected get stars(): number[] {
    return Array.from({ length: this.maxStars }, (_, i) => i + 1);
  }
}
